(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-email-signup"] && !Shopify.designMode) return;
  try {
    
if (!window.mhRevealInit) {
  window.mhRevealInit = true;
  if ('IntersectionObserver' in window) {
    var _mhIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); _mhIo.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mh-reveal').forEach(function(el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; _mhIo.observe(el); });
  } else {
    document.querySelectorAll('.mh-reveal').forEach(function(el) { el.classList.add('is-visible'); });
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-faq"] && !Shopify.designMode) return;
  try {
    

/* — Scroll reveal (global guard) — */
if (!window.mhRevealInit) {
  window.mhRevealInit = true;
  if ('IntersectionObserver' in window) {
    var _mhIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); _mhIo.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mh-reveal').forEach(function(el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; _mhIo.observe(el); });
  } else {
    document.querySelectorAll('.mh-reveal').forEach(function(el) { el.classList.add('is-visible'); });
  }
}

/* — FAQ accordion — one open at a time — */
if (!window.mhFaqInit) {
  window.mhFaqInit = true;
  document.querySelectorAll('.mh-faq__item').forEach(function(d) {
    d.addEventListener('toggle', function() {
      if (d.open) {
        document.querySelectorAll('.mh-faq__item[open]').forEach(function(o) {
          if (o !== d) o.removeAttribute('open');
        });
      }
    });
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-final-cta"] && !Shopify.designMode) return;
  try {
    
if (!window.mhRevealInit) {
  window.mhRevealInit = true;
  if ('IntersectionObserver' in window) {
    var _mhIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); _mhIo.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mh-reveal').forEach(function(el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; _mhIo.observe(el); });
  } else {
    document.querySelectorAll('.mh-reveal').forEach(function(el) { el.classList.add('is-visible'); });
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-offer"] && !Shopify.designMode) return;
  try {
    
if (!window.mhRevealInit) {
  window.mhRevealInit = true;
  var _io = new (window.IntersectionObserver || Object)(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); _io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.mh-reveal').forEach(function(el, i) {
    el.style.transitionDelay = (i % 4) * 60 + 'ms';
    _io.observe(el);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-pain"] && !Shopify.designMode) return;
  try {
    
if (!window.mhRevealInit) {
  window.mhRevealInit = true;
  if ('IntersectionObserver' in window) {
    var _mhIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); _mhIo.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mh-reveal').forEach(function(el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; _mhIo.observe(el); });
  } else {
    document.querySelectorAll('.mh-reveal').forEach(function(el) { el.classList.add('is-visible'); });
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-reviews"] && !Shopify.designMode) return;
  try {
    

/* — Scroll reveal (global guard — runs once per page) — */
if (!window.mhRevealInit) {
  window.mhRevealInit = true;
  if ('IntersectionObserver' in window) {
    var _mhIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); _mhIo.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mh-reveal').forEach(function(el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; _mhIo.observe(el); });
  } else {
    document.querySelectorAll('.mh-reveal').forEach(function(el) { el.classList.add('is-visible'); });
  }
}

/* — Pair short reviews into double-stacked slides — */
(function() {
  var reviewTrack = document.getElementById('mhReviewsTrack');
  if (!reviewTrack) return;
  var slides = Array.from(reviewTrack.querySelectorAll(':scope > .mh-carousel__slide'));
  var SHORT = 250;
  var newSlides = [], i = 0;
  while (i < slides.length) {
    var s = slides[i];
    var q = s.querySelector('.mh-review-card__quote');
    var len = q ? q.textContent.trim().length : 9999;
    if (len < SHORT && i + 1 < slides.length) {
      var s2 = slides[i + 1];
      var q2 = s2.querySelector('.mh-review-card__quote');
      var len2 = q2 ? q2.textContent.trim().length : 9999;
      if (len2 < SHORT) {
        var paired = document.createElement('div');
        paired.className = 'mh-carousel__slide mh-carousel__slide--paired';
        paired.setAttribute('role', 'listitem');
        var c1 = s.querySelector('.mh-review-card');
        var c2 = s2.querySelector('.mh-review-card');
        if (c1) paired.appendChild(c1);
        if (c2) paired.appendChild(c2);
        newSlides.push(paired); i += 2; continue;
      }
    }
    newSlides.push(s); i++;
  }
  if (newSlides.length < slides.length) {
    reviewTrack.innerHTML = '';
    newSlides.forEach(function(sl) { reviewTrack.appendChild(sl); });
  }
})();

/* — Reviews infinite-loop carousel — */
(function() {
  var track    = document.getElementById('mhReviewsTrack');
  var dotsWrap = document.getElementById('mhReviewsDots');
  var prevBtn  = document.getElementById('mhReviewsPrev');
  var nextBtn  = document.getElementById('mhReviewsNext');
  if (!track) return;

  var realSlides = Array.from(track.querySelectorAll('.mh-carousel__slide'));
  var total = realSlides.length;
  if (total === 0) return;

  var copyA = realSlides.map(function(s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden','true'); return c; });
  var copyC = realSlides.map(function(s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden','true'); return c; });
  copyA.slice().reverse().forEach(function(c) { track.insertBefore(c, track.firstChild); });
  copyC.forEach(function(c) { track.appendChild(c); });

  realSlides.forEach(function(_, i) {
    var d = document.createElement('button');
    d.className = 'mh-carousel__dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Go to review ' + (i + 1));
    d.addEventListener('click', function() { if (!busy) goToReal(i); });
    dotsWrap.appendChild(d);
  });
  var dots = Array.from(dotsWrap.querySelectorAll('.mh-carousel__dot'));

  var busy = false, current = 0;
  function sw() { var s = track.querySelector('.mh-carousel__slide'); return s ? s.offsetWidth + 16 : 0; }
  function setDots(i) { dots.forEach(function(d, j) { d.classList.toggle('is-active', j === i); }); }
  function instantScrollTo(left) { track.style.scrollBehavior = 'auto'; track.scrollLeft = left; void track.offsetWidth; track.style.scrollBehavior = ''; }
  function posOfReal(i) { return sw() * (total + i); }
  function recenter() {
    var s = sw(), copyW = s * total, left = track.scrollLeft;
    if (left < copyW) instantScrollTo(left + copyW);
    else if (left >= 2 * copyW) instantScrollTo(left - copyW);
  }

  instantScrollTo(posOfReal(0));

  function goToReal(i) {
    current = i; setDots(i);
    var s = sw(), copyW = s * total, left = track.scrollLeft;
    var copyOffset = Math.round(left / copyW) * copyW;
    busy = true;
    track.scrollTo({ left: copyOffset + s * i, behavior: 'smooth' });
    setTimeout(function() { recenter(); busy = false; }, 480);
  }

  if (nextBtn) nextBtn.addEventListener('click', function() {
    if (busy) return;
    var next = (current + 1) % total;
    busy = true; track.scrollTo({ left: track.scrollLeft + sw(), behavior: 'smooth' });
    current = next; setDots(next);
    setTimeout(function() { recenter(); busy = false; }, 480);
  });
  if (prevBtn) prevBtn.addEventListener('click', function() {
    if (busy) return;
    var prev = (current - 1 + total) % total;
    busy = true; track.scrollTo({ left: track.scrollLeft - sw(), behavior: 'smooth' });
    current = prev; setDots(prev);
    setTimeout(function() { recenter(); busy = false; }, 480);
  });
  track.addEventListener('scroll', function() {
    if (busy) return;
    var s = sw(); if (!s) return;
    var realIdx = Math.round(track.scrollLeft % (s * total) / s) % total;
    if (realIdx !== current) { current = realIdx; setDots(realIdx); }
  }, { passive: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-showroom"] && !Shopify.designMode) return;
  try {
    

/* — Scroll reveal (global guard) — */
if (!window.mhRevealInit) {
  window.mhRevealInit = true;
  if ('IntersectionObserver' in window) {
    var _mhIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); _mhIo.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mh-reveal').forEach(function(el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; _mhIo.observe(el); });
  } else {
    document.querySelectorAll('.mh-reveal').forEach(function(el) { el.classList.add('is-visible'); });
  }
}

/* — Gallery infinite-loop carousel — */
(function() {
  var track    = document.getElementById('mhCarouselTrack');
  var dotsWrap = document.getElementById('mhCarouselDots');
  var prevBtn  = document.getElementById('mhCarouselPrev');
  var nextBtn  = document.getElementById('mhCarouselNext');
  if (!track) return;

  var realSlides = Array.from(track.querySelectorAll('.mh-carousel__slide'));
  var total = realSlides.length;
  if (total === 0) return;

  var copyA = realSlides.map(function(s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden','true'); return c; });
  var copyC = realSlides.map(function(s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden','true'); return c; });
  copyA.slice().reverse().forEach(function(c) { track.insertBefore(c, track.firstChild); });
  copyC.forEach(function(c) { track.appendChild(c); });

  realSlides.forEach(function(_, i) {
    var d = document.createElement('button');
    d.className = 'mh-carousel__dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Go to photo ' + (i + 1));
    d.addEventListener('click', function() { if (!busy) goToReal(i); });
    dotsWrap.appendChild(d);
  });
  var dots = Array.from(dotsWrap.querySelectorAll('.mh-carousel__dot'));

  var busy = false, current = 0;
  function sw() { var s = track.querySelector('.mh-carousel__slide'); return s ? s.offsetWidth + 16 : 0; }
  function setDots(i) { dots.forEach(function(d, j) { d.classList.toggle('is-active', j === i); }); }
  function instantScrollTo(left) { track.style.scrollBehavior = 'auto'; track.scrollLeft = left; void track.offsetWidth; track.style.scrollBehavior = ''; }
  function recenter() {
    var s = sw(), copyW = s * total, left = track.scrollLeft;
    if (left < copyW) instantScrollTo(left + copyW);
    else if (left >= 2 * copyW) instantScrollTo(left - copyW);
  }

  instantScrollTo(sw() * total);

  function goToReal(i) {
    current = i; setDots(i);
    var s = sw(), copyW = s * total, left = track.scrollLeft;
    busy = true;
    track.scrollTo({ left: Math.round(left / copyW) * copyW + s * i, behavior: 'smooth' });
    setTimeout(function() { recenter(); busy = false; }, 480);
  }

  if (nextBtn) nextBtn.addEventListener('click', function() {
    if (busy) return;
    var next = (current + 1) % total;
    busy = true; track.scrollTo({ left: track.scrollLeft + sw(), behavior: 'smooth' });
    current = next; setDots(next);
    setTimeout(function() { recenter(); busy = false; }, 480);
  });
  if (prevBtn) prevBtn.addEventListener('click', function() {
    if (busy) return;
    var prev = (current - 1 + total) % total;
    busy = true; track.scrollTo({ left: track.scrollLeft - sw(), behavior: 'smooth' });
    current = prev; setDots(prev);
    setTimeout(function() { recenter(); busy = false; }, 480);
  });
  track.addEventListener('scroll', function() {
    if (busy) return;
    var s = sw(); if (!s) return;
    var realIdx = Math.round(track.scrollLeft % (s * total) / s) % total;
    if (realIdx !== current) { current = realIdx; setDots(realIdx); }
  }, { passive: true });
})();


  } catch(e) { console.error(e); }
})();
})();
